import { render, staticRenderFns } from "./InfoSection.vue?vue&type=template&id=33f599b8&"
import script from "./InfoSection.vue?vue&type=script&lang=ts&"
export * from "./InfoSection.vue?vue&type=script&lang=ts&"
import style0 from "./InfoSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports